import React from 'react';
import Row from "../../../SDFormTemplate/Row";
import Section from '../../../SDFormTemplate/Section';
import Accordion from 'components/Common/Accordion/Accordion';

function PriorityEvents({ setInvalidConditions, setFormData }) {
  
  const title = 'Priority Events';

  const IN_ALARM_OPTIONS_ENDPOINT = `/ServiceDesk/getInAlarmTypes`

  const priorityEventsSection = ([
    <Section
      key='priority_events_section'
      title='in_alarm'
      altTitle='Choose Priority Events status'
      type='dropdown'
      placeholder='Select an alarm type...'
      inlineWrapperStyles={{ minHeight: '350px' }}
      disableDefaultStyles={true}
      mapFromEndpoint={{ endpoint: IN_ALARM_OPTIONS_ENDPOINT, dispatch: false }}
      setInvalidConditions={setInvalidConditions}
      setFormData={setFormData}
    />
  ])

  return (
    <div key="priority_events">
      <Row
        key='row_5'
        sections={[
          (index) => (
            <Accordion
              key='accordion_5'
              title={title}
              accordionHeaderSection={true}
              accordionHeaderContents={{
                size: 'md',
                message: 'Enable and configure Priority Events - our powerful AMS feature.',
              }}
              showNumberInHeader={false}
              headerNumber={index + 1}
              content={[
                priorityEventsSection,
              ]}
            />
          )
        ]}
      />
    </div>
  )
}

export default PriorityEvents;
